// 文件类型验证工具
export const validateExcelFile = (file) => {
  const acceptExtensions = ['.xlsx', '.xls', '.csv'];
  const fileName = file.name.toLowerCase();
  return acceptExtensions.some(ext => fileName.endsWith(ext));
};

export const getInvalidFileTypeMessage = () => '仅支持 .xlsx, .xls, .csv 格式的文件！';